export function replaceHostInUrl(badUrl: string, goodUrl: string) {
	const bad = new URL(badUrl)
	const good = new URL(goodUrl)

	bad.host = good.host
	return String(bad)
}
